import baseUrl from "../config/baseUrl";

const previewChasingEmail = async ({
  token,
  contact_id,
  template_id,
  document_request_id,
  exclude_document_request_id,
}) => {
  try {
    const docIdParam = document_request_id
      ? `&document_request_id=${encodeURIComponent(document_request_id)}`
      : "";
    const excludeDocIdParam = exclude_document_request_id
      ? `&exclude_document_request_id=${encodeURIComponent(exclude_document_request_id)}`
      : "";
    const response = await fetch(`${baseUrl}/api/preview-chasing-email?contact_id=${contact_id}&template_id=${template_id}${docIdParam}${excludeDocIdParam}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default previewChasingEmail;
